export enum StudentBtnTypeOption {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  highlight = 'highlight',
  danger = 'danger'
}
